<template >
  <div class="priceManagement-page">
    <div class="all-content-container">
      <div class="screen-all-container">
        <el-tabs v-model="activeName2" type="card" @tab-click="handleClick" class="el-tab_top">
            <el-tab-pane label="审批模板" name="first" style="margin-right:30px;"  >
              <userManagementone></userManagementone>
           </el-tab-pane>
          <el-tab-pane label="审批配置" name="second">
            <roleManagement></roleManagement>
          </el-tab-pane>
          <el-tab-pane label="审批记录" name="third">
            <organization></organization>
          </el-tab-pane>
          <!-- <el-tab-pane label="系统信息" name="fourth"> -->
            <!-- <systemMessage></systemMessage> -->
          <!-- </el-tab-pane> -->
          <!-- <el-tab-pane label="系统日志" name="six">
            <systemLog></systemLog> -->
          <!-- </el-tab-pane>  -->
        </el-tabs>
      </div>
    </div>
    <div class="pagination-container">
      <div class="pagination-content-container"></div>
    </div>
  </div>
</template>
<script>
import userManagementone from "../approvalManagement/approvalTemplate";
import roleManagement from "../approvalManagement/approvalConfiguration";
import organization from "../approvalManagement/approvalRecord";
// import organization from "@/components/systemManagement/organization";
// import systemMessage from "@/components/systemManagement/systemMessage";
// import systemLog from "@/components/systemManagement/systemLog";
export default {
  name: "approval",
  components: {
    userManagementone,
    roleManagement,
    organization
    
    
  },
  data() {
    return {
        activeName2: 'second',

    };
  },
  created(){},
  created(){},
  methods: {
    handleClick() {}
    
  }
};
</script>
<style scoped>
/* @import "../../style/userManagement.scss"; */
</style>